import type { VisitorCustomFieldValueInput } from 'lane-shared/domains/visitorManagement/types/VisitorType';

export function buildVisitorCustomFieldValuesFromFormState(
  valueByConfigId: Record<string, string | string[]>,
  orderedConfigIds: readonly string[]
): VisitorCustomFieldValueInput[] {
  return orderedConfigIds
    .map(configId => {
      const raw = valueByConfigId[configId] ?? [];
      const parts = (Array.isArray(raw) ? raw : [raw]).map(p => p.trim()).filter(Boolean);
      return { customFieldConfigId: configId, value: parts };
    })
    .filter(entry => entry.value.length > 0);
}
